module.exports = __webpack_public_path__ + "img/device1.ef586165.png";